import * as React from 'react'
import { useSelector } from 'react-redux'
import * as yup from 'yup'

import { Formik } from 'formik'

import {
  selectManageAgreements,
  flipCard,
  setSalesTeamsIds,
  setAssigneeIds,
} from '@user/store/dashboard/widgets/manageAgreements/manageAgreements'

import { FormFields } from './FormFields'
import { useHandleSubmit, useInitData } from '../../hooks'

const validationSchema = yup.object({
  numDays: yup
    .number()
    .integer('Please enter an integer value.')
    .min(0, 'Please enter a positive value.')
    .max(180, 'Please enter a value less than 180.')
    .required('Please enter a number between 0 and 180.'),
})

export default function FormWrapper() {
  const widgetData = useSelector(selectManageAgreements)
  const { handleManageAgreementsSubmit } = useHandleSubmit({
    flipCard,
    setSalesTeamsIds,
    setAssigneeIds,
  })

  const { initSalesTeams, initOwnersIds, initSalesTeamsIds, initNumDays } =
    useInitData(widgetData)

  return (
    <Formik
      initialValues={{
        assigneeIds: initOwnersIds,
        numDays: initNumDays,
        salesTeamIds: initSalesTeamsIds,
      }}
      onSubmit={handleManageAgreementsSubmit}
      validationSchema={validationSchema}
    >
      <FormFields
        salesTeams={initSalesTeams}
        assigneeIds={widgetData.assigneeIds}
        initData={{
          assigneeIds: initOwnersIds,
          salesTeamIds: initSalesTeamsIds,
        }}
      />
    </Formik>
  )
}

export { FormWrapper }
